<template>
  <div>奖金设置</div>
</template>

<script>
export default {

}
</script>

<style>

</style>